module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp1_9005.6f97e036.png";